import { StockSymbol } from '@benzinga/session';

export type WidgetLinkingID = string | null;
export type WidgetLinkHue = number | null;
export type WidgetLinkEventType = 'ticker_selected' | (string & { __link_event: any });

export interface WidgetLinkEvent {
  [x: string | number | symbol]: unknown;
  type: WidgetLinkEventType;
}

export interface WidgetLink {
  hue: WidgetLinkHue;
  id: WidgetLinkingID;
  title: string;
  events: WidgetLinkEvent[];
}

export interface TickerSelectedEvent extends WidgetLinkEvent {
  type: 'ticker_selected';
  symbol: StockSymbol | null;
}

export const isTickerSelectedEvent = (e: WidgetLinkEvent): e is TickerSelectedEvent => e.type === 'ticker_selected';
